import { render, staticRenderFns } from "./archivesBorrowing.vue?vue&type=template&id=1349ff65&scoped=true&"
import script from "./archivesBorrowing.vue?vue&type=script&lang=js&"
export * from "./archivesBorrowing.vue?vue&type=script&lang=js&"
import style0 from "./archivesBorrowing.vue?vue&type=style&index=0&id=1349ff65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1349ff65",
  null
  
)

export default component.exports